<template>
  <div
    :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']"
    v-show="domStatus"
    @scroll.native="onScroll"
	id="product-con"
  >
    <div
      class="header acea-row row-center-wrapper"
      :style="'opacity:' + opacity"
      ref="header"
    >
      <div
        class="item"
        :class="navActive === index ? 'on' : ''"
        v-for="(item, index) in navList"
        :key="index"
        @click="asideTap(index)"
      >
        {{ item }}
      </div>
    </div>
    <div id="title0">
	  <buy-person :buyperson="buyperson" :showBuyperson="showBuyperson"></buy-person>
      <ProductConSwiper :imgUrls="imgUrls"></ProductConSwiper>
      <div class="nav acea-row row-between-wrapper">
        <div class="money">
          ￥
           <span class="num" v-if="storeInfo.section_price == storeInfo.price">{{ storeInfo.price }}</span>
            <span class="num" v-else>{{ storeInfo.section_price }}</span>
          <div class="y-money" v-text="'￥' + storeInfo.ot_price"></div>
        </div>
        <div class="acea-row row-middle" v-if="storeInfo.is_time">
          <div class="times">
            <div>距秒杀结束仅剩</div>
            <CountDown
              :is-day="false"
              :tip-text="''"
              :day-text="''"
              :hour-text="' : '"
              :minute-text="' : '"
              :second-text="''"
              :datatime="datatime"
			  v-on:activityEnd="activityEnd"
            ></CountDown>
          </div>
        </div>
      </div>
      <div class="wrapperRush">
        <div class="introduce acea-row row-between">
          <div class="infor" v-text="storeInfo.title"></div>
          <div
            class="iconfont icon-fenxiang"
            @click="setPosterImageStatus"
          ></div>
        </div>
        <div class="label acea-row row-middle">
          <div class="stock">
            累计销售：{{ storeInfo.total ? storeInfo.total : 0 }} 件
          </div>
          <!-- <div>
            限量: {{ storeInfo.quota_show ? storeInfo.quota_show : 0 }} 件
          </div> -->
        </div>
      </div>
      <div
        class="attribute acea-row row-between-wrapper"
        @click="selecAttrTap"
        v-if="attr.productAttr.length"
      >
        <div style="width: 95%;height: 0.45rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
          {{ attrTxt }}：<span class="atterTxt">{{ attrValue }}</span>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
    </div>
    <!-- <div class="userEvaluation" id="title1">
      <div class="title acea-row row-between-wrapper">
        <div v-text="'用户评价(' + replyCount + ')'"></div>
        <div class="praise" @click="goReply">
          <span class="font-color-red" v-text="replyChance + '%'"></span
          >好评率<span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <UserEvaluation :reply="reply" v-if="reply.length !== 0"></UserEvaluation>
    </div> -->
	
	<div class="superior" v-if="goodList.length > 0" id="title2">
	  <div class="title acea-row row-center-wrapper">
	    <img src="@assets/images/ling.png" />
	    <div class="titleTxt">优品推荐</div>
	    <img src="@assets/images/ling.png" />
	  </div>
	  <template>
	    <div class="slider-banner banner">
	      <swiper :options="swiperRecommend" v-if="goodList.length">
	        <swiper-slide v-for="(item, index) in goodList" :key="index">
	          <div class="list acea-row row-middle">
	            <div
	              class="item"
	              v-for="val in item.list"
	              :key="val.image"
	              @click="goGoods(val)"
	            >
	              <div class="pictrue">
	                <img :src="val.image" />
	                <span
	                  class="pictrue_log pictrue_log_class"
	                  v-if="val.activity && val.activity.type === '1'"
	                  >秒杀</span
	                >
	                <span
	                  class="pictrue_log pictrue_log_class"
	                  v-if="val.activity && val.activity.type === '2'"
	                  >砍价</span
	                >
	                <span
	                  class="pictrue_log pictrue_log_class"
	                  v-if="val.activity && val.activity.type === '3'"
	                  >拼团</span
	                >
	              </div>
	              <div class="name line1">{{ val.store_name }}</div>
	              <div class="money font-color-red">¥{{ val.price }}</div>
	            </div>
	          </div>
	        </swiper-slide>
	        <div class="swiper-pagination" slot="pagination"></div>
	      </swiper>
	    </div>
	  </template>
	</div>
	
    <div class="product-intro" id="title2">
      <div class="title">产品介绍</div>
      <div class="conter" v-html="storeInfo.description"></div>
    </div>
    <div style="height:1.2rem;"></div>
    <div class="footerRush acea-row row-between-wrapper">
      <!-- <div
        class="customerSer acea-row row-center-wrapper row-column"
        @click="$router.push({ path: '/customer/list' })"
      > --> <div
        class="customerSer acea-row row-center-wrapper row-column"
        @click="$common.setqimoChatClick()"
      v-if="kefu_display_status == 1">
        <div class="iconfont icon-kefu"></div>
        <div>客服</div>
      </div>
      <div
        class="item acea-row row-center-wrapper row-column"
        @click="setCollect"
      >
        <div
          class="iconfont"
          :class="storeInfo.userCollect ? 'icon-shoucang1' : 'icon-shoucang'"
        ></div>
        <div>收藏</div>
      </div>
	  <router-link
	    :to="'/cart'"
	    class="item animated"
	    :class="animated === true ? 'bounceIn' : ''"
		v-if="storeInfo.is_cart === 1"
	  >
	    <div class="iconfont icon-gouwuche1">
	      <span class="num bg-color-red" v-if="CartCount > 0">{{
	        CartCount
	      }}</span>
	    </div>
	    <div>购物车</div>
	  </router-link>
	  <div
	    class="bnt acea-row"
	    v-if="storeInfo.activity_status === 1 && storeInfo.is_cart === 1"
	  >
	     <div class="joinCart" @click="joinCart">加入购物车</div>
	    <div class="buy" @click="tapBuy">立即抢购</div>
	  </div>
	  <div
	    class="bnt acea-row"
	    v-if="storeInfo.activity_status === 1 && storeInfo.is_cart === 0"
	  >
	    <div class="buy buy-sole" @click="tapBuy">立即抢购</div>
	  </div>
      <!-- <div
        class="bnt acea-row"
        v-if="
          storeInfo.activity_status === 1 &&
            attr.productSelect.quota > 0 &&
            attr.productSelect.stock > 0
        "
      >
         <div class="joinCart" @click="joinCart">加入购物车</div>
        <div class="buy" @click="tapBuy">立即抢购</div>
      </div> -->
      <!-- <div
        class="bnt acea-row"
        v-if="
          storeInfo.activity_status === 1 &&
            (attr.productSelect.quota <= 0 ||
              attr.productSelect.stock <= 0)
        "
      >
        <div class="joinCart" @click="openAlone">原价购买</div>
        <div class="buy bg-color-hui">已售罄</div>
      </div> -->
      <div class="bnt acea-row" v-if="storeInfo.activity_status === 2 ">
        <div class="joinCart" @click="openAlone">原价购买</div>
        <div class="buy bg-color-hui">即将开始</div>
      </div>
      <div class="bnt acea-row" v-if="storeInfo.activity_status === 0 ">
        <div class="joinCart" @click="openAlone">原价购买</div>
        <div class="buy bg-color-hui">已结束</div>
      </div>
    </div>
    <ProductWindows3 v-on:changeFun="changeFun" :attr="attr"></ProductWindows3>
    <StorePoster
      v-on:setPosterImageStatus="setPosterImageStatus"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></StorePoster>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { mapGetters } from "vuex";
import BuyPerson from "@components/BuyPerson";
import ProductConSwiper from "@components/ProductConSwiper";
import CountDown from "@components/CountDown";
import ProductWindows3 from "@components/ProductWindows3";
import StorePoster from "@components/StorePoster";
import UserEvaluation from "@components/UserEvaluation";
import { getSeckillDetailQuick } from "@api/activity";
import { postCartAdd, getCartCount } from "@api/store";
import { imageBase64 } from "@api/public";

import { openShareAll } from "@libs/wechat";
import { goShopDetail } from "@libs/order";
import { getCollectAdd, getCollectDel } from "@api/user";
import debounce from "lodash.debounce";
const NAME = "SeckillDetails";
export default {
  name: "SeckillDetails",
  components: {
	swiper,
	swiperSlide,
	BuyPerson,
    ProductConSwiper,
    CountDown,
    ProductWindows3,
    StorePoster,
    UserEvaluation
  },
  props: {},
  data: function() {
    return {
	  showBuyperson: false,
	  buyperson: [],
      domStatus: false,
      posterData: {
        image: "",
        title: "",
        price: "",
        code: ""
      },
      posterImageStatus: false,
      action: "",
      imgUrls: [],
      storeInfo: [],
      replyCount: 0,
      replyChance: 0,
      reply: [],
      cartNum: 1,
      attr: {
        cartAttr: false,
        productSelect: {
          image: "",
          store_name: "",
          price: "",
          quota: 0,
          unique: "",
          cart_num: 1,
          quota_show: 0,
          stock: 0
        },
		RuleData: {},
        productAttr: []
      },
	  RuleDatares:[],
      datatime: 0,
      attrTxt: "请选择",
      isOpen: false, //是否打开属性组件
      attrValue: "",
      cart_num: 1, //购买数量
      productValue: [],
      navList: [],
      lock: false,
      navActive: 0,
      opacity: 0,
      storeSelfMention: true,
      storeItems: {},
      activity: [],
	  swiperRecommend: {
	    pagination: {
	      el: ".swiper-pagination",
	      clickable: true
	    },
	    autoplay: false,
	    loop: false,
	    speed: 1000,
	    observer: true,
	    observeParents: true
	  },
	  goodList: [],
     kefu_display_status: 2,
	 CartCount: 0
    };
  },
  computed: mapGetters(["isLogin"]),
  watch: {
    $route: function(n) {
      var that = this;
      if (n.name === NAME) {
        that.mountedStart();
      }
    }
  },
  mounted: function() {
    document.addEventListener("scroll", this.onScroll, false);
    window.addEventListener("scroll", this.handleScroll);
    this.mountedStart();
  },
  methods: {
	//活动结束
	activityEnd(status){
		//console.log(status)
		this.storeInfo.activity_status = status;
	},
    // 去评价页面
    goReply: function() {
      var that = this;
      that.$router.push({
        path: "/evaluate_list/" + that.storeInfo.product_id
      });
    },
    //收藏商品
    setCollect: function() {
      let that = this,
        id = that.storeInfo.product_id,
        category = "product";
      if (that.storeInfo.userCollect) {
        getCollectDel(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      } else {
        getCollectAdd(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      }
    },
    //打开属性插件；
    selecAttrTap: function() {
      if (this.storeInfo.activity_status === 1) {
        this.attr.cartAttr = true;
        this.isOpen = true;
	     	document.getElementById("product-con").classList.add("noscoll");
      }
    },
    openAlone: function() {
      if(this.storeInfo.product_id == 221 || this.storeInfo.product_id == 245){
        this.$router.push({ path: "/product/detail3/" + this.storeInfo.product_id });
        return
      }
      this.$router.push({ path: "/detail/" + this.storeInfo.product_id });
    },
    mountedStart: function() {
      var that = this;
      let id = that.$route.params.id;
      getSeckillDetailQuick(id).then(res => {
        that.datatime = parseInt(res.data.storeInfo.stop_time);
        that.$set(that, "storeInfo", res.data.storeInfo);
		that.$set(that, "buyperson", res.data.purchase_information);
		that.showBuyperson = true;
		that.$set(that.attr, "RuleData", res.data.RuleData);
        that.$set(that, "imgUrls", res.data.storeInfo.images);
        that.$set(that, "replyCount", res.data.replyCount);
        that.$set(that, "replyChance", res.data.replyChance);
        if (res.data.reply)
          that.$set(that, "reply", Array.from(res.data.reply) || []);
        that.posterData.image = that.storeInfo.image_base;
        that.attr.productAttr = res.data.productAttr;
        that.kefu_display_status = res.data.kefu_display_status ? res.data.kefu_display_status : 2;
        that.productValue = res.data.productValue;
		let good_list = res.data.good_list || [];
		let goodArray = [];
		let count = Math.ceil(good_list.length / 6);
		for (let i = 0; i < count; i++) {
		  var list = good_list.slice(i * 6, i * 6 + 6);
		  if (list.length) goodArray.push({ list: list });
		}
		that.$set(that, "goodList", goodArray);
        let navList = ["商品", "评价", "详情"];
        that.navList = navList;
        that.updateTitle();
        if (that.storeInfo.title.length > 30) {
          that.posterData.title = that.storeInfo.title.substring(0, 30) + "...";
        } else {
          that.posterData.title = that.storeInfo.title;
        }
        that.posterData.price = that.storeInfo.price;
        that.posterData.code = that.storeInfo.code_base;
        that.setProductSelect();
        that.domStatus = true;
		that.getCartCount();
        that.getImageBase64();
        that.setShare();
        if (that.attr.productAttr != 0) that.DefaultSelect();
		if(that.attr.RuleData.spec_type == 1){
			that.getsubject();
		}
      }).catch(err => {
        console.log(err)
		  that.$dialog.error(err.msg);
		  // that.$router.go(-1);
	  });
    },
    setShare: function() {
      this.$wechat.isWeixin() &&
        openShareAll({
          desc: this.storeInfo.info,
          title: this.storeInfo.title,
          link: location.href,
          imgUrl: this.storeInfo.image
        });
    },
    getImageBase64: function() {
      let that = this;
      imageBase64(this.posterData.image, that.posterData.code).then(res => {
        that.posterData.image = res.data.image;
        that.posterData.code = res.data.code;
      });
    },
    updateTitle() {
      document.title = this.storeInfo.title || this.$route.meta.title;
    },
    setPosterImageStatus: function() {
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function(opt) {
	  var that = this;
	  if(opt.action == "ChangeSubject"){
		  that.RuleDatares = opt.value;
	  }
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    changeattr: function(res) {
      var that = this;
      that.attr.cartAttr = res;
    },
    //选择属性；
    ChangeAttr: function(res) {
      let productSelect = this.productValue[res];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "quota", productSelect.quota);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(
          this.attr.productSelect,
          "stock",
          productSelect.product_stock
        );
        this.$set(
          this.attr.productSelect,
          "quota_show",
          productSelect.quota_show
        );
        this.$set(this, "attrValue", res);
        this.$set(this, "attrTxt", "已选择");
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "quota", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this.attr.productSelect, "quota_show", 0);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    ChangeCartNum: function(res) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      if (productSelect === undefined) return;
      let quota = productSelect.quota || 0;
      let num = this.attr.productSelect;
      if (res) {
        num.cart_num++;
        if (num.cart_num > quota) {
          this.$set(this.attr.productSelect, "cart_num", quota);
          this.$set(this, "cart_num", quota);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    //默认选中属性；
    DefaultSelect: function() {
      let productAttr = this.attr.productAttr,
        value = [];
      for (var key in this.productValue) {
        if (this.productValue[key].quota > 0) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }
      for (let i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", value[i]);
      }
      //sort();排序函数:数字-英文-汉字；
      // let productSelect = this.productValue[value.sort().join(",")];
      let productSelect = this.productValue[value.join(",")];
      if (productSelect && productAttr.length) {
        this.$set(this.attr.productSelect, "store_name", this.storeInfo.title);
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "quota", productSelect.quota);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(
          this.attr.productSelect,
          "stock",
          productSelect.product_stock
        );
        this.$set(
          this.attr.productSelect,
          "quota_show",
          productSelect.quota_show
        );
        // this.$set(this, "attrValue", value.sort().join(","));
		this.$set(this, "attrValue", value.join(","));
        this.$set(this, "attrTxt", "已选择");
      } else if (!productSelect && productAttr.length) {
        this.$set(this.attr.productSelect, "store_name", this.storeInfo.title);
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "quota", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this.attr.productSelect, "quota_show", 0);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      } else if (!productSelect && !productAttr.length) {
        this.$set(this.attr.productSelect, "store_name", this.storeInfo.title);
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "quota", 0);
        this.$set(this.attr.productSelect, "quota_show", 0);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(
          this.attr.productSelect,
          "unique",
          this.storeInfo.unique || ""
        );
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
	  this.isCheckedValue(1);
    },
	//获取被选中科目
	
	getsubject: function(){
		let that = this;
		let RuleData = that.attr.RuleData.attr_values[that.attr.productAttr[1].index];
		let value = [];
		for(let i=0;i<RuleData.length;i++){
			if(RuleData[i].check){
				value.push(RuleData[i].attr);
			}
		}
		that.RuleDatares = value;
	},
	//判断属性是否可选
	isCheckedValue: function(type){
	  let that = this;
	  let productAttr = this.attr.productAttr;
	  let return_d = true
	  if(type != 1){
	     return_d = false;
	  }
	  for (let i = 0; i < productAttr.length; i++) {
	    for (let j = 0; j < productAttr[i].attr_value.length; j++) {
	       //console.log(productAttr[i].index+'4444444444');
	      if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
	        //console.log(type+'---------333333');
	        if(productAttr[i].attr_value[j].disabled_info){
	           for (var key in productAttr[i].attr_value[j].disabled_info_data) {
	              for(var ke in productAttr[i].attr_value[j].disabled_info_data[key]){
	               // console.log(productAttr[i].attr_value[j].disabled_info_data[key][ke]);
	                //console.log(ke);
	                this.attr.productAttr[key]['attr_value'][ke]['disabled'] = return_d;
	              }
	              //console.log(productAttr[i].attr_value[j].disabled_info_data[key]);
	            }
	        }
	      }
	    }
	  }
	  // if(!that.attr.productValue[value.join(",")]){
	  //   that.isChecked = false;
	  // }
	  //return that.isChecked;
	},
    setProductSelect: function() {
      var that = this;
      var attr = that.attr;
      attr.productSelect.image = that.storeInfo.image;
      attr.productSelect.store_name = that.storeInfo.title;
      attr.productSelect.price = that.storeInfo.price;
      attr.productSelect.quota = 0;
      attr.productSelect.stock = 0;
      attr.cartAttr = false;
      that.$set(that, "attr", attr);
    },
	//获取购物车数量
	getCartCount: function(isAnima) {
	  let that = this;
	  const isLogin = that.isLogin;
	  if (isLogin) {
	    getCartCount({ numType: 0 }).then(res => {
	      that.CartCount = res.data.count;
	      //加入购物车后重置属性
	      if (isAnima) {
	        that.animated = true;
	        setTimeout(function() {
	          that.animated = false;
	        }, 500);
	      }
	    });
	  }
	},
	//  点击加入购物车按钮
	joinCart: function() {
	  //0=加入购物车
	  this.goCat(0);
	},
	//立即购买；
	tapBuy: function() {
	  //  1=直接购买
	  this.goCat(1);
	},
    goCat: function(news) {
      var that = this;
      if (that.attr.cartAttr == false) {
        that.attr.cartAttr = !this.attr.attrcartAttr;
      } else {
        var data = {};
        data.productId = that.storeInfo.product_id;
        data.cartNum = that.attr.productSelect.cart_num;
        data.uniqueId = that.attr.productSelect.unique;
        data.secKillId = that.storeInfo.id;
		data.spec_type = that.attr.RuleData.spec_type,
		data.spec_values = that.RuleDatares.join(','),
        data.new = news;
		if(that.attr.RuleData.spec_type == 1){
			var checkedarr = that.attr.RuleData.attr_values[that.attr.productAttr[1].index];
			var check_num = [];
			for(var i = 0; i < checkedarr.length; i++){
			  if(checkedarr[i].check){
				  check_num.push(checkedarr[i].check);
			  }
			}
			//console.log(check_num.length);
			var sepc_num = that.attr.RuleData.attr_value[that.attr.productAttr[1].index].sepc_num;
			if(check_num.length < sepc_num || data.spec_values == ""){
				that.$layer.msg("选择科目不能小于"+sepc_num+"科");
			}else{
				postCartAdd(data).then(function(res) {
					  //console.log(res);
					  that.isOpen = false;
					  that.attr.cartAttr = false;
					  document.getElementById("product-con").classList.remove("noscoll");
					  if (news) {
					  	that.$router.push({ path: "/order/submit/" + res.data.cartId });
					  } else {
						that.$dialog.toast({
							mes: "添加购物车成功",
							callback: () => {
							  that.getCartCount(true);
							}
						});
					  }
				 }).catch(res => {
					  that.isOpen = false;
					  document.getElementById("product-con").classList.remove("noscoll");
					  return that.$dialog.toast({ mes: res.msg });
				 });
			}
		}else{
				  postCartAdd(data).then(function(res) {
					  //console.log(res);
					  that.isOpen = false;
					  that.attr.cartAttr = false;
					  document.getElementById("product-con").classList.remove("noscoll");
					  if (news) {
					  	that.$router.push({ path: "/order/submit/" + res.data.cartId });
					  } else {
						that.$dialog.toast({
							mes: "添加购物车成功",
							callback: () => {
							  that.getCartCount(true);
							}
						});
					  }
				   }).catch(res => {
					  that.isOpen = false;
					  document.getElementById("product-con").classList.remove("noscoll");
					  return that.$dialog.toast({ mes: res.msg });
				   });
		}
        
      }
    },
    handleScroll() {
      let top = document.body.scrollTop || document.documentElement.scrollTop;
      let opacity = top / 350;
      opacity = opacity > 1 ? 1 : opacity;
      this.opacity = opacity;
    },
    goGoods(item) {
	  console.log(item)
    goShopDetail(item).then(() => {
      window.scroll(0, 0);
      this.$router.push({ path: "/detail/" + item.id });
    });
  },
    asideTap(a) {
      this.$nextTick(() => {
        let index = a;
        this.navActive = index;
        let element = document.querySelector("#title" + index);
        const top =
          element.offsetTop - this.$refs.header.offsetHeight - window.scrollY;
        this.lock = true;
        window.scrollBy({ top, left: 0, behavior: "smooth" });
      });
    },
    onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = [];
      titles.push(document.querySelector("#title0"));
      titles.push(document.querySelector("#title1"));
      titles.push(document.querySelector("#title2"));
      titles.reduce((initial, title, index) => {
        if (
          !document.querySelector("#title0") &&
          !document.querySelector("#title1") &&
          !document.querySelector("#title2")
        ) {
          return;
        }
        if (initial) return initial;
        if (scrollY + headerHeight < title.offsetTop + title.offsetHeight) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
    }, 500)
  },
  
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.product-con .header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 0.96rem;
  font-size: 0.3rem !important;
  color: #050505;
  background-color: #fff;
  z-index: 11;
  border-bottom: 0.01rem solid #eee;
}
.product-con .header .item {
  position: relative;
  margin: 0 0.35rem;
  font-size: 0.3rem !important;
}
.product-con .header .item.on:before {
  position: absolute;
  width: 0.6rem;
  height: 0.05rem;
  background-repeat: no-repeat;
  content: "";
  background: linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  background: -webkit-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  background: -moz-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  bottom: -0.1rem;
}
.noscroll {
  height: 100%;
  overflow: hidden;
}
.bg-color-hui {
  background: #bbbbbb !important;
  line-height: 0.76rem;
  text-align: center;
}
.item {
  font-size: 0.2rem;
  color: #666;
  text-align: center;
}
.product-con .nav {
  padding: 0 0.2rem;
}
.product-con .bnt {
    width: 4.44rem;
    height: 0.76rem;
    color: #fff;
    font-size: 0.28rem;
}

.icon-shoucang1 {
  color: #e93323;
}
.product-con .footerRush .item .iconfont.icon-gouwuche1 {
    position: relative;
}
.product-con .footerRush .item .iconfont.icon-gouwuche1 .num{
	color: #fff;
	position: absolute;
	font-size: .18rem;
	border-radius: 2rem;
	top: -.1rem;
	right: 0;
	height: .3rem;
	line-height: .3rem;
	padding: 0 .08rem;
	min-width: .3rem;
}
.product-con .superior {
  background-color: #fff;
  margin-top: 0.2rem;
}
.product-con .superior .title {
  height: 0.98rem;
}
.product-con .superior .title img {
  width: 0.3rem;
  height: 0.3rem;
}
.product-con .superior .title .titleTxt {
  margin: 0 0.2rem;
  font-size: 0.3rem;
  background-image: linear-gradient(to right, #f57a37 0%, #f21b07 100%);
  background-image: -webkit-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
  background-image: -moz-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.product-con .superior .slider-banner {
  width: 6.9rem;
  margin: 0 auto;
  padding-bottom: 0.2rem;
}
.product-con .superior .slider-banner .list {
  width: 100%;
  padding-bottom: 0.2rem;
}
.product-con .superior .slider-banner .list .item {
  width: 2.15rem;
  margin: 0 0.21rem 0.2rem 0;
  font-size: 0.26rem;
}
.product-con .superior .slider-banner .list .item:nth-of-type(3n) {
  margin-right: 0;
}
.product-con .superior .slider-banner .list .item .pictrue {
  width: 100%;
  height: 2.15rem;
  position: relative;
}
.product-con .superior .slider-banner .list .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.product-con .superior .slider-banner .list .item .name {
  color: #282828;
  margin-top: 0.12rem;
}
.product-con .superior .slider-banner .swiper-pagination-bullet {
  background-color: #999;
}
.product-con .superior .slider-banner .swiper-pagination-bullet-active {
  background-color: #e93323;
}
.product-con .bnt .buy-sole{
	border-radius: 0.5rem;
	width: 4.3rem;
}
@media screen and (min-width:960px){
	.product-con .header {
	  left: 0;
	  height: 0.48rem;
	  font-size: 0.15rem!important;
	  width: 3.75rem;
	  left: 50%;transform: translate(-50%);-webkit-transform: translate(-50%);
	}
	.product-con .header .item {
	  margin: 0 0.175rem;
	  font-size: 0.15rem!important;
	}
	.product-con .header .item.on:before {
	  width: 0.3rem;
	  height: 0.025rem;
	  bottom: -0.05rem;
	}
	.bg-color-hui {
	  line-height: 0.38rem;
	}
	.item {
	  font-size: 0.1rem;
	}
	.product-con .nav {
	  padding: 0 0.1rem;
	}
	.product-con .bnt {
	    width: 2.22rem;
	    height: 0.38rem;
	    font-size: 0.14rem;
	}
	.product-con .footerRush .item .iconfont.icon-gouwuche1 .num{
		font-size: 0.09rem;
		border-radius: 1rem;
		top: -0.05rem;
		height: .15rem;
		line-height: .07rem;
		padding: 0.04rem;
		min-width: .15rem;
	}
	.product-con .superior {
	  margin-top: 0.1rem;
	}
	.product-con .superior .title {
	  height: 0.49rem;
	}
	.product-con .superior .title img {
	  width: 0.15rem;
	  height: 0.15rem;
	}
	.product-con .superior .title .titleTxt {
	  margin: 0 0.1rem;
	  font-size: 0.15rem;
	}
	.product-con .superior .slider-banner {
	  width: 3.45rem;
	  padding-bottom: 0.1rem;
	}
	.product-con .superior .slider-banner .list {
	  padding-bottom: 0.1rem;
	}
	.product-con .superior .slider-banner .list .item {
	  width: 1.07rem;
	  margin: 0 0.11rem 0.1rem 0;
	  font-size: 0.13rem;
	}
	.product-con .superior .slider-banner .list .item .pictrue {
	  height: 1.07rem;
	}
	.product-con .superior .slider-banner .list .item .name {
	  margin-top: 0.06rem;
	}
	.product-con .bnt .buy-sole{
		border-radius: 0.25rem;
		width: 2.15rem;
	}
}
</style>
